export const dom = {
    carousel: $('#image-carousel'),
    carouselInner: $('.carousel-inner'),
    similarImagesContainer: $('#similar-images'),
    categoryButtons: $('.category-btn')
};
